export default "__VITE_ASSET__QNj4FTVa__"